import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { OAuthService, JwksValidationHandler, AuthConfig } from 'angular-oauth2-oidc';
import { LoadConfigService } from './shared/load-config.service';
import { Configuration } from './app.constants';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent {
    private static supportedLanguages: string[] = ["en", "nl", "da"];
    private discoveryDocUrl;
    public loading: boolean = true;
    private authConfig: AuthConfig;
    constructor(private _router: Router,
        private _httpClient: HttpClient,
        private translate: TranslateService,
        private oauthService: OAuthService,
        private loadConfigService: LoadConfigService,
        private _config: Configuration) {

        

       

        //old oidc lib.

        // if (this.oidcSecurityService.moduleSetup) {
        //     console.log("moduleSetup");
        //     this.doCallbackLogicIfRequired();
        // } else {
        //     console.log("module is not setup");
        //     this.oidcSecurityService.onModuleSetup.subscribe(() => {
        //         console.log("moduleSetup eventually");
        //         this.doCallbackLogicIfRequired();
        //     });
        // }

        var language: string;
        if (window.navigator.languages) {
            language = window.navigator.languages[0];
        } else {
            language = window.navigator['userLanguage'] || window.navigator.language;
        }

        if (language == null) {
            language = "en";
        } else {
            language = language.substr(0, 2);
        }

        if (AppComponent.supportedLanguages.indexOf(language) < 0) {
            language = "en";
        }

        console.log(`Using language: ${language}`);

        translate.setDefaultLang(language);


    }

    async ngOnInit() {

        this.loadConfigService.loadConfig().subscribe(result => {
         

            let authConfig: AuthConfig = {
                issuer: result.stsServer,
                requireHttps: false,
                redirectUri: result.redirect_url,
                logoutUrl: result.redirect_url,
                postLogoutRedirectUri:result.post_logout_redirect_uri,
                clientId: result.client_id,
                scope: result.scope,
                showDebugInformation: result.log_console_debug_active
             };

             this._config.Server = result.apiServer;

             this.discoveryDocUrl = `${authConfig.issuer}/.well-known/openid-configuration`;
             this.oauthService.configure(authConfig);
             this.oauthService.tokenValidationHandler = new JwksValidationHandler();
             this.oauthService.setStorage(localStorage);
             
             if (!this.oauthService.hasValidIdToken() ||
                 !this.oauthService.hasValidAccessToken()) {
                 this.oauthService.loadDiscoveryDocument(this.discoveryDocUrl).then(_ => {
                     this.oauthService.tryLogin().then(result => {


                         if (this.oauthService.state) {
                             this._router.navigate([this.oauthService.state]);
                         }
     
                         if (!this.oauthService.hasValidIdToken() || !this.oauthService.hasValidAccessToken()) {
                             this.oauthService.initImplicitFlow(location.pathname);
                         }
                         else {
                             this.loading = false;
                         }
                     });
                 });
             }
             else {
                 this.loading = false;
             }

             
        });

   

    }

    ngOnDestroy(): void {
        //this.oidcSecurityService.onModuleSetup.unsubscribe();
    }


    login() {
    }

    logout() {

        this.oauthService.logOut();
        //this.oidcSecurityService.logoff();
    }

    private doCallbackLogicIfRequired() {
        if (window.location.hash) {
            //this.oidcSecurityService.authorizedCallback();
        } else {

            //this.oidcSecurityService.authorize();
        }
    }
}
